/** Pixen Intrigue — Encyclopedia English overrides. Courtly-fae voice. Only keys with world flavor are overridden; the rest inherit the shared shell. */
export const encyclopediaPixEn = {
  // EncyclopediaPage
  'encyclopedia.page.seoDescription':
    'Search the living archive of Pixen Intrigue — rivals, favors, courts, locations and more.',
  'encyclopedia.page.subtitle': 'The living archive of every rival, favor, and legend at Court.',
  'encyclopedia.page.systemNotLivePrefix': 'The glamour has not yet parted for',
  'encyclopedia.page.systemNotLiveSuffix':
    '. No lore bound to this system has slipped through — its archive waits beyond the veil.',
  'encyclopedia.page.settingNotLiveSuffix':
    ' are still being charted — its entries are not yet bound to the setting. Until the cartographers finish, nothing answers here.',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Unlock {name} (Pixen Intrigue content)',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Search the Court',
  'encyclopedia.globalSearch.placeholder': 'Search rivals, favors, courts, locations…',
  'encyclopedia.globalSearch.loading': 'Consulting the Archive…',
  'encyclopedia.globalSearch.empty': 'Nothing stirs at Court for "{q}".',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Pixen Intrigue content — unlock to read',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.body':
    "Pixen Intrigue's own rivals, favors, and legends are bound to the core book. The open SRD canon stays free — but to walk the courts of the fae, claim the book.",
  'encyclopedia.lockedGate.unlockCta': 'Unlock Pixen Intrigue',
  'encyclopedia.lockedGate.backerNote':
    'Backers who pledged for Pixen Intrigue already own this — sign in to unlock it on your account.',

  // EntityDetailPage
  'encyclopedia.detail.addError': 'Could not reach the campaign ledger. Try again later.',
  'encyclopedia.detail.seoDescription': '{name} — a {label} in the Pixen Intrigue Encyclopedia.',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.emptyBody': 'Be the first to discuss this entry with fellow courtiers.',

  // tabs/ClaimsTab
  'encyclopedia.claims.emptyBody': 'No courtier has yet woven their legend into this entry.',
}
